import { render, staticRenderFns } from "./CookieConsentBanner.vue?vue&type=template&id=6c847897&scoped=true"
import script from "./CookieConsentBanner.vue?vue&type=script&lang=js"
export * from "./CookieConsentBanner.vue?vue&type=script&lang=js"
import style0 from "./CookieConsentBanner.vue?vue&type=style&index=0&id=6c847897&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c847897",
  null
  
)

export default component.exports